import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=e39edc9e"
import script from "./Comentarios.vue?vue&type=script&lang=js"
export * from "./Comentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports